<template>
  <div class="bg-white">
    <CommHeader />
    <CommSwipe :dataList="swipeDataList" />
    <div class="common-margin-top common-letter-spacing container">
      <div>
        <p class="common-padding-top font-20 text-center">这个场景我们仅提供支付服务，合作方自有系与<!--广东快付-->银典科技合作前后的变化要点。</p>
        <table class="table table-bordered table-striped common-margin-top common-padding-top">
          <thead>
            <tr><th>合作前</th><th>合作后</th></tr>
          </thead>
          <tbody class="font-14">
            <tr><td>对接微信、支付宝平台</td>
              <td>对接广东支付（支持微信、支付宝、云闪付等。）</td></tr>
            <tr><td>条码支付已经接入使用。小程序支付、H5支付、APP支付正在对接</td>
              <td>对接了条码支付、对接了快付收银台。智能判别使用场景，接入一次同时支持扫码支付、小程序支付、H5支付、APP支付。</td></tr>
            <tr><td>所有加盟商收款进公司对公账户，公司做二清给商户，经常没按实结算，偶尔打款错误。</td>
              <td>加盟商收款近抽成、货款分账至公司对公账户，其它资金直接进加盟商账户。</td></tr>
            <tr><td>商家刷脸需求自行采购刷脸设备</td>
              <td>统一从快付采购刷脸设备，价格优惠，产品统一。</td></tr>
          </tbody>
        </table>
      </div>
    </div>
    <CommBrand />
    <CommFooter />
  </div>
</template>

<script>
import CommHeader from '@/components/CommHeader'
import CommSwipe from '@/components/CommSwipe'
import CommBrand from '@/components/CommBrand'
import CommFooter from '@/components/CommFooter'
export default {
  name: 'home',
  components: {
    CommHeader,
    CommSwipe,
    CommBrand,
    CommFooter
  },
  data () {
    return {
      swipeDataList: [{img: require('images/home/sw-img1.jpg'),
        caption: '加盟连锁店场景',
        url: '#',
        describe: '某连锁店，已拥有几十家超市，拥有完备的供应链和完善的商超管理方法，拥有小程序线上下单门店自取或送货上门。' +
          '主要靠复制加盟店发展门店、扩大品牌影响力。'
      }]
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/product/Jmls.vue